import React from 'react';

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Dashboard</h1>
        <button className="logout-button">Logout</button>
      </header>

      <main className="dashboard-content">
        <section className="dashboard-summary">
          <h2>Welcome back!</h2>
          <p>Here&apos;s your overview</p>
        </section>

        <section className="dashboard-widgets">
          <div className="widget">
            <h3>Statistics</h3>
            <p>Your stats will appear here</p>
          </div>

          <div className="widget">
            <h3>Recent Activity</h3>
            <p>Your recent activities will appear here</p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
